export const TaskRequest = {
  getBoards : {},
  postBoard : { name: "" },
  getTasks : { boardid: 1 },
  postTasks : {
    title: "",
    description: "",
    status: "TODO",
    boardId: null,
    taskId: null,
    subtasks: {}
  },
  postSubtasks : {
    title: "",
    isCompleted: false,
    boardid: 0,
    tasksid: 0,
  },
}

export default TaskRequest;
